export default () => (
  <path d="M19.06 7.06a1.5 1.5 0 0 0-2.12-2.12L12 9.88 7.06 4.94a1.5 1.5 0 0 0-2.12 2.12L9.88 12l-4.94 4.94a1.5 1.5 0 0 0 2.12 2.12L12 14.12l4.94 4.94a1.5 1.5 0 0 0 2.12-2.12L14.12 12l4.94-4.94Z" />
);
